import { Spinner } from '@heroui/react';

const Loading = () => {
    return (
        <div className="flex items-center justify-center py-[10%]">
            <Spinner />
        </div>
    );
};

export default Loading;
